import React from 'react';
import FadingLine  from '../Components/FadingLine';

function Footer() {
  return (
    <footer className="footer bg-gray-900 text-center m-0 text-size-14 text-gray-400 p-4">
      <FadingLine  />
      <p className='mt-4'> Copyright &copy; {new Date().getFullYear()} Indra Rimal. All rights reserved.</p>
      {/* can add more content here, like social media links, etc. */}
    </footer>
  );
}

export default Footer;